export default "__VITE_ASSET__6a68aaf0__"